/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  PrincipalRemoteSessionBinding,
  PrincipalRemoteSessionBinding$inboundSchema,
} from "./principalremotesessionbinding.js";

export type BindingRefreshResult = {
  binding?: PrincipalRemoteSessionBinding | undefined;
  /**
   * Whether this popup committed an exact grant and replaced the attachment. False means no matching callback completed; the attempt is consumed without changing the attachment.
   */
  completed: boolean;
};

/** @internal */
export const BindingRefreshResult$inboundSchema: z.ZodMiniType<
  BindingRefreshResult,
  unknown
> = z.object({
  binding: z.optional(PrincipalRemoteSessionBinding$inboundSchema),
  completed: z.boolean(),
});

export function bindingRefreshResultFromJSON(
  jsonString: string,
): SafeParseResult<BindingRefreshResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => BindingRefreshResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'BindingRefreshResult' from JSON`,
  );
}
